/* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import {
  Box,
  Breadcrumbs,
  Button,
  TextField,
  Typography,
  Grid,
  Link,
  Divider,
  CircularProgress,
  Backdrop,
  Tabs,
  Tab,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMounted from "../../hooks/useMounted";
import { useCallback, useState, useEffect } from "react";
import { useParams, Link as RouterLink } from "react-router-dom";
import { campaignApi } from "../../api/campaignApi";
import useAuth from "../../hooks/useAuth";
import ChevronRightIcon from "../../icons/ChevronRight";
import * as moment from "moment";
import CampaignDetails from "../../pages/dashboard/CampaignDetails";
import CampaignLearner from "./CampaignLearner";
import AttributionIcon from "@mui/icons-material/Attribution";
import AddIcon from "@mui/icons-material/Add";
import DateAdapter from "@mui/lab/AdapterMoment";
import * as React from "react";
import * as Yup from "yup";
import CampaignStatsTab from "./CampaignStatsTab";
import CampaignLogs from "./CampaignLogs";
import DialogReinjection from "./DialogReinjection";
import DialogRetrieve from "./DialogRetrieve";
import DialogAddCommercials from "./DialogAddCommercials";
import DialogManageCommercials from "./DialogManageCommercials";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getTone, toneAlpha, lightVeil, darkVeil, greyAlpha, grey } from '../../theme/tones';
import usePermissions from '../../hooks/usePermissions';

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const tabs = [
  { label: "Statistiques", value: "statistiques" },
  { label: "Contacts", value: "Contacts" },
];

const tabs2 = [
  { label: "Statistiques", value: "statistiques" },
  { label: "Contacts", value: "Contacts" },
  { label: "Activités", value: "logs" },
];

const CampaignInfo = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const { can } = usePermissions();
  const mounted = useMounted();
  const { idCampaign } = useParams();
  const [donnees, setDonnees] = useState({});
  const [openAddCommercial, setOpenAddCommercial] = useState(false);
  const [openAddcommercials, setOpenAddcommercials] = useState(false);
  const [openReinjection, setOpenReinjection] = useState(false);
  const [openRetrieve, setOpenRetrieve] = useState(false);
  const [campaignValues, setCampaignValues] = useState({
    name: "",
    start_date: "",
    end_date: "",
  });
  const [isEditing, setIsEditing] = useState({
    name: false,
    start_date: false,
    end_date: false,
  });
  const [progressionProspects, setProgressionProspects] = useState(0);
  const steps = [
    "Informations de la réinjection",
    "Récapitulatif",
  ];
  const stepsRetrieve = ["Informations du rattrapage", "Récapitulatif"];
  const [activeStep, setActiveStep] = useState(0);
  const [activeStepRetrieve, setActiveStepRetrieve] = useState(0);
  const [qualifications, setQualifications] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([
    { qualification: "Attente" },
    { qualification: "Ancien commentaire" },
    { qualification: "Erreur" },
    { qualification: "Non - Déjà fait" },
    { qualification: "Non - Pas intéressé" },
    { qualification: "Numéro incorrect" },
    { qualification: "Pas répondu" },
    { qualification: "Refus" },
    { qualification: "Sans statut" },
    { qualification: "Souhaite un email" },
    { qualification: "Appel entrant" },
    { qualification: "À rappeler" },
    { qualification: "Rappel" },
  ]);
  const [selectedStatusRetrieve, setSelectedStatusRetrieve] = useState([
    { qualification: "Attente" },
    { qualification: "Ancien commentaire" },
    { qualification: "Erreur" },
    { qualification: "Non - Déjà fait" },
    { qualification: "Non - Pas intéressé" },
    { qualification: "Numéro incorrect" },
    { qualification: "Pas répondu" },
    { qualification: "Refus" },
    { qualification: "Sans statut" },
    { qualification: "Souhaite un email" },
    { qualification: "Appel entrant" },
    { qualification: "À rappeler" },
    { qualification: "Rappel" },
  ]);
  const [selectedCommercials, setSelectedCommercials] = useState([]);
  const [selectedCommercialsEquitable, setSelectedCommercialsEquitable] =
    useState([]);
  const [commercialToAdd, setCommercialToAdd] = useState(null);
  const [commercialsToAdd, setCommercialsToAdd] = useState([]);
  const [commercialsCampaign, setCommercialsCampaign] = useState([]);
  const [commercialsCampaignManage, setCommercialsCampaignManage] = useState(
    []
  );
  const [
    commercialsCampaignManageNotTreated,
    setCommercialsCampaignManageNotTreated,
  ] = useState([]);
  const [selectedCommercialToAdd, setSelectedCommercialToAdd] = useState({});
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [leftChecked, setLeftChecked] = useState([]);
  const [rightChecked, setRightChecked] = useState([]);
  const [displayCustom, setDisplayCustom] = useState(false);
  const [displayNumberCustomers, setDisplayNumberCustomers] = useState(false);
  const [
    displayNumberCustomersNotAttributed,
    setDisplayNumberCustomersNotAttributed,
  ] = useState(false);
  const [displayReattribution, setDisplayReattribution] = useState(false);
  const [displayEquitable, setDisplayEquitable] = useState(false);
  const [selectedCommercial, setSelectedCommercial] = useState(null);
  const [typeCampaign, setTypeCampaign] = useState("");
  const [nbCustomers, setNbCustomers] = useState(0);
  const [nbCustomersNotAttributed, setNbCustomersNotAttributed] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [selectedCommercialsReinjection, setSelectedCommercialsReinjection] =
    useState([]);
  const [selectedCommercialReinjection, setSelectedCommercialReinjection] =
    useState(null);
  const [selectedCommercialRetrieve, setSelectedCommercialRetrieve] =
    useState(null);
  const [currentTab, setCurrentTab] = useState("statistiques");
  // Onglets autorisés par le rôle. Repli : les administrateurs avaient la liste
  // complète (tabs2), les autres profils la liste courte (tabs).
  const canSeeTab = (value) => can(`campaign.tab.${value.toLowerCase()}`,
    user.access_level === 0 ? tabs2.some((t) => t.value === value) : tabs.some((t) => t.value === value));
  const visibleTabs = tabs2.filter((tab) => canSeeTab(tab.value));
  const showTab = (value) => currentTab === value && canSeeTab(value);
  const [formIsEmpty, setFormIsEmpty] = useState(true);

  const getCampaignInfo = useCallback(async () => {
    try {
      let data = {};
      // on récupère les commerciaux non affectées à la campagne
      const dataCommercialsToAdd = await campaignApi.getCommercialsForAdding(
        idCampaign,
        localStorage.getItem("accessToken")
      );
      const dataCommercialsCampaign = await campaignApi.getCommercialsCampaign(
        idCampaign,
        localStorage.getItem("accessToken")
      );
      const dataCommercialsCampaignManage =
        await campaignApi.getCommercialsCampaignManage(
          idCampaign,
          localStorage.getItem("accessToken")
        );
      data = await campaignApi.getCampaignInfo(
        idCampaign,
        localStorage.getItem("accessToken")
      );
      const dataQualifications = await campaignApi.getQualificationsReinj(
        localStorage.getItem("accessToken")
      );
      const tempLeft = {};
      const tempRight = {};
      const tempChecked = {};
      const tempLeftChecked = {};
      const tempRightChecked = {};
      if (data.length === 0) {
        throw new Error("La campagne n'existe pas");
      }

      if (mounted.current) {
        setDonnees(data);
        setProgressionProspects(data.progression);
        setCampaignValues({
          name: data.campaign.name,
          start_date: data.campaign.start_date,
          end_date: data.campaign.end_date,
        });
        setQualifications(dataQualifications.data);
        setCommercialToAdd(dataCommercialsToAdd.data);
        setCommercialsCampaign(dataCommercialsCampaign.data);
        setCommercialsCampaignManageNotTreated(dataCommercialsCampaign.data);
        setCommercialsCampaignManage(dataCommercialsCampaignManage.data);
        // initialisation des array d'array
        data.commercial.forEach((item) => {
          tempLeft[item.caller_id] = data.commercials;
          tempRight[item.caller_id] = [];
          tempChecked[item.caller_id] = [];
          tempLeftChecked[item.caller_id] = [];
          tempRightChecked[item.caller_id] = [];
        });
        setLeft(tempLeft);
        setRight(tempRight);
        setChecked(tempChecked);
        setLeftChecked(tempLeftChecked);
        setRightChecked(tempRightChecked);
        setIsLoadingPage(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, idCampaign]);

  useEffect(() => {
    if (
      commercialsToAdd.length === 0 ||
      (displayNumberCustomers === false &&
        displayReattribution === false &&
        displayEquitable === false &&
        displayNumberCustomersNotAttributed === false)
    ) {
      setFormIsEmpty(true);
    } else {
      setFormIsEmpty(false);
    }
  }, [
    commercialsToAdd,
    displayNumberCustomers,
    displayReattribution,
    displayEquitable,
    displayNumberCustomersNotAttributed,
  ]);

  useEffect(() => {
    getCampaignInfo();
  }, [getCampaignInfo]);

  useEffect(() => {
    if (selectedCommercial !== null) {
      setLeftChecked((prevLeftChecked) => {
        const tempLeftChecked = { ...prevLeftChecked };
        tempLeftChecked[selectedCommercial] = intersection(
          checked[selectedCommercial] || [],
          left[selectedCommercial] || []
        );
        return tempLeftChecked;
      });
      setRightChecked((prevRightChecked) => {
        const tempRightChecked = { ...prevRightChecked };
        tempRightChecked[selectedCommercial] = intersection(
          checked[selectedCommercial] || [],
          right[selectedCommercial] || []
        );
        return tempRightChecked;
      });
    }
  }, [selectedCommercial, checked, left, right]);

  const handleToggle = (field) => {
    const tempIsEditing = { ...isEditing };
    tempIsEditing[field] = !tempIsEditing[field];
    setIsEditing(tempIsEditing);
  };

  const stopEditing = (field) => {
    setIsEditing((prev) => ({ ...prev, [field]: false }));
  };

  // Enregistre une date (début/fin) sans passer par handleToggle : on ferme
  // l'édition de façon explicite pour éviter que l'appel asynchrone et le
  // onClose du DatePicker ne se croisent et ne rouvrent le champ.
  const handleChangeDate = async (field, value) => {
    setCampaignValues((prev) => ({ ...prev, [field]: value }));
    setIsEditing((prev) => ({ ...prev, [field]: false }));
    try {
      await campaignApi.editCampaign(
        field,
        value,
        donnees.campaign.id,
        localStorage.getItem("accessToken")
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleToggleList = (items, value) => () => {
    const currentIndex = checked[selectedCommercial]
      .map((e) => e.id)
      .indexOf(items[value].id);

    const newChecked = { ...checked };

    if (currentIndex === -1) {
      newChecked[selectedCommercial].push(items[value]);
    } else {
      newChecked[selectedCommercial].splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleChangeData = async (field, value) => {
    try {
      await campaignApi.editCampaign(
        field,
        value,
        donnees.campaign.id,
        localStorage.getItem("accessToken")
      );
      handleToggle(field);
    } catch (err) {
      console.error(err);
    }
  };

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  const handleOpenAddcommercials = () => {
    setOpenAddcommercials(true);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBackRetrieve = () => {
    setActiveStepRetrieve((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNextRetrieve = () => {
    setActiveStepRetrieve((prevActiveStep) => prevActiveStep + 1);
  };

  const initialValues = {
    assignment: "Même assignation",
  };

  const validationSchema = Yup.object().shape({
    assignment: Yup.string().required(),
  });

  const handleLeavingDialog = useCallback(() => {
    if (!openReinjection) {
      const tempRight = {};
      const tempChecked = {};
      const tempLeftChecked = {};
      const tempRightChecked = {};
      if (Object.keys(donnees).length !== 0 && donnees.constructor === Object) {
        donnees.commercial.forEach((item) => {
          tempRight[item.caller_id] = [];
          tempChecked[item.caller_id] = [];
          tempLeftChecked[item.caller_id] = [];
          tempRightChecked[item.caller_id] = [];
        });
        setRight(tempRight);
        setChecked(tempChecked);
        setLeftChecked(tempLeftChecked);
        setRightChecked(tempRightChecked);
        setSelectedCommercial(null);
        setDisplayCustom(false);
        setActiveStep(0);
        setSelectedStatus([]);
        setSelectedCommercialsReinjection([]);
      }
    }
  }, [openReinjection, donnees]);

  const handleLeavingDialogRetrieve = useCallback(() => {
    if (!openRetrieve) {
      if (Object.keys(donnees).length !== 0 && donnees.constructor === Object) {
        setActiveStepRetrieve(0);
        setSelectedStatusRetrieve([]);
      }
    }
  }, [openRetrieve, donnees]);

  const handleLeavingDialogAddCommercial = useCallback(() => {
    if (!openAddCommercial) {
      setDisplayNumberCustomers(false);
      setDisplayReattribution(false);
      setDisplayEquitable(false);
      setSelectedCommercialToAdd({});
      setSelectedCommercials([]);
      setSelectedCommercialsEquitable([]);
      setDisplayNumberCustomersNotAttributed(false);
    }
  }, [openAddCommercial]);

  const handleLeavingDialogAddcommercials = useCallback(() => {
    if (!openAddcommercials) {
      setDisplayNumberCustomers(false);
      setDisplayReattribution(false);
      setDisplayEquitable(false);
      setSelectedCommercialToAdd({});
      setSelectedCommercials([]);
      setSelectedCommercialsEquitable([]);
      setCommercialsToAdd([]);
      setDisplayNumberCustomersNotAttributed(false);
    }
  }, [openAddcommercials]);

  const handleSelectedCommercialsReinjection = useCallback((commercialId) => {
    const tempSelectedCommercialsReinjection = [
      ...selectedCommercialsReinjection,
    ];
    const index = tempSelectedCommercialsReinjection.indexOf(commercialId);
    if (index === -1) {
      tempSelectedCommercialsReinjection.push(commercialId);
    } else {
      tempSelectedCommercialsReinjection.splice(index, 1);
    }
    setSelectedCommercialsReinjection(tempSelectedCommercialsReinjection);
  }, [selectedCommercialsReinjection]);

  const [openManageCommercials, setOpenManageCommercials] = useState(false);

  const handleOpenManageCommercials = () => {
    setOpenManageCommercials(true);
  };

  useEffect(() => {
    handleLeavingDialog();
  }, [handleLeavingDialog]);

  useEffect(() => {
    handleLeavingDialogRetrieve();
  }, [handleLeavingDialogRetrieve]);

  useEffect(() => {
    handleLeavingDialogAddCommercial();
  }, [handleLeavingDialogAddCommercial]);

  useEffect(() => {
    handleLeavingDialogAddcommercials();
  }, [handleLeavingDialogAddcommercials]);

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        minHeight: "100%",
        py: 4,
        px: { xs: 2, md: 4 }
      }}
    >
      <DialogReinjection
        openReinjection={openReinjection}
        setOpenReinjection={setOpenReinjection}
        initialValues={initialValues}
        validationSchema={validationSchema}
        setIsLoading={setIsLoading}
        idCampaign={idCampaign}
        typeCampaign={typeCampaign}
        selectedStatus={selectedStatus}
        right={right}
        donnees={donnees}
        selectedCommercialsReinjection={selectedCommercialsReinjection}
        selectedCommercialReinjection={selectedCommercialReinjection}
        activeStep={activeStep}
        steps={steps}
        qualifications={qualifications}
        setSelectedStatus={setSelectedStatus}
        setDisplayCustom={setDisplayCustom}
        displayCustom={displayCustom}
        handleSelectedCommercialsReinjection={
          handleSelectedCommercialsReinjection
        }
        selectedCommercial={selectedCommercial}
        handleBack={handleBack}
        handleNext={handleNext}
        isLoading={isLoading}
      />
      <DialogRetrieve
        initialValues={initialValues}
        validationSchema={validationSchema}
        setIsLoading={setIsLoading}
        idCampaign={idCampaign}
        qualifications={qualifications}
        isLoading={isLoading}
        selectedStatusRetrieve={selectedStatusRetrieve}
        selectedCommercialRetrieve={selectedCommercialRetrieve}
        openRetrieve={openRetrieve}
        setOpenRetrieve={setOpenRetrieve}
        activeStepRetrieve={activeStepRetrieve}
        stepsRetrieve={stepsRetrieve}
        setSelectedStatusRetrieve={setSelectedStatusRetrieve}
        handleBackRetrieve={handleBackRetrieve}
        handleNextRetrieve={handleNextRetrieve}
      />

      <DialogAddCommercials
        setIsLoading={setIsLoading}
        idCampaign={idCampaign}
        isLoading={isLoading}
        openAddcommercials={openAddcommercials}
        setOpenAddcommercials={setOpenAddcommercials}
        donnees={donnees}
        commercialsToAdd={commercialsToAdd}
        selectedCommercials={selectedCommercials}
        selectedCommercialsEquitable={selectedCommercialsEquitable}
        typeCampaign={typeCampaign}
        commercialToAdd={commercialToAdd}
        setCommercialsToAdd={setCommercialsToAdd}
        setDisplayEquitable={setDisplayEquitable}
        setDisplayNumberCustomers={setDisplayNumberCustomers}
        setDisplayNumberCustomersNotAttributed={
          setDisplayNumberCustomersNotAttributed
        }
        setDisplayReattribution={setDisplayReattribution}
        displayReattribution={displayReattribution}
        commercialsCampaign={commercialsCampaign}
        setSelectedCommercials={setSelectedCommercials}
        setSelectedCommercialsEquitable={setSelectedCommercialsEquitable}
        displayEquitable={displayEquitable}
        displayNumberCustomers={displayNumberCustomers}
        displayNumberCustomersNotAttributed={
          displayNumberCustomersNotAttributed
        }
        setNbCustomers={setNbCustomers}
        setNbCustomersNotAttributed={setNbCustomersNotAttributed}
        formIsEmpty={formIsEmpty}
      />

      <DialogManageCommercials
        setIsLoading={setIsLoading}
        idCampaign={idCampaign}
        isLoading={isLoading}
        openManageCommercials={openManageCommercials}
        commercialsCampaignManageNotTreated={
          commercialsCampaignManageNotTreated
        }
        commercialsCampaignManage={commercialsCampaignManage}
        setOpenManageCommercials={setOpenManageCommercials}
      />

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={8}>
          <Typography
            color="textPrimary"
            variant="h4"
            sx={{ fontWeight: 800, letterSpacing: '-0.5px', color: 'text.primary' }}
          >
            Statistiques de la campagne
          </Typography>
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<ChevronRightIcon fontSize="small" />}
            sx={{ mt: 1, mb: 2 }}
          >
            <Link
              color="textSecondary"
              component={RouterLink}
              to="/dashboard"
              variant="subtitle2"
              sx={{ textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
            >
              Tableau de bord
            </Link>
            <Link
              color="textSecondary"
              component={RouterLink}
              to="/dashboard/campaign"
              variant="subtitle2"
              sx={{ textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
            >
              Campagne
            </Link>
            <Typography color="textPrimary" variant="subtitle2" sx={{ fontWeight: 600 }}>
              Informations
            </Typography>
          </Breadcrumbs>
        </Grid>
        
        {can('campaign.update', user.access_level === 0) && (
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Button
              color="primary"
              variant="contained"
              startIcon={<AddIcon fontSize="small" />}
              onClick={handleOpenAddcommercials}
              sx={{
                background: `linear-gradient(135deg, ${getTone('blue').base} 0%, ${getTone('blue').color} 100%)`,
                boxShadow: `0 4px 12px 0 ${toneAlpha('blue', 0.25)}`,
                color: grey(0),
                borderRadius: '12px',
                px: 2.5,
                py: 1,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                  background: `linear-gradient(135deg, ${getTone('blue').color} 0%, ${getTone('blue').deepest} 100%)`,
                  transform: 'translateY(-1px)',
                  boxShadow: `0 6px 16px 0 ${toneAlpha('blue', 0.35)}`
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              Ajouter un commercial
            </Button>
            <Button
              color="primary"
              variant="outlined"
              startIcon={<AttributionIcon fontSize="small" />}
              onClick={handleOpenManageCommercials}
              sx={{
                borderRadius: '12px',
                px: 2.5,
                py: 1,
                textTransform: 'none',
                fontWeight: 600,
                borderColor: toneAlpha('blue', 0.5),
                '&:hover': {
                  borderColor: 'primary.main',
                  backgroundColor: toneAlpha('blue', 0.04),
                  transform: 'translateY(-1px)'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              Gérer les commerciaux
            </Button>
          </Grid>
        )}
      </Grid>

      <Box sx={{ mb: 4, backgroundColor: theme.palette.mode === 'light' ? grey(50) : lightVeil(0.02), p: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            {isEditing.name ? (
              <TextField
                fullWidth
                label="Nom de la campagne"
                type="text"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleChangeData("name", campaignValues.name);
                  }
                }}
                onChange={(event) => {
                  const tempCampaignValues = { ...campaignValues };
                  tempCampaignValues.name = event.target.value;
                  setCampaignValues(tempCampaignValues);
                }}
                value={campaignValues.name}
                variant="outlined"
                InputProps={{
                  sx: { borderRadius: '12px' }
                }}
              />
            ) : (
              <Box 
                onClick={() => can('campaign.update', user.access_level === 0) ? handleToggle("name") : null}
                sx={{ 
                  cursor: can('campaign.update', user.access_level === 0) ? 'pointer' : 'default',
                  '&:hover': can('campaign.update', user.access_level === 0) ? { opacity: 0.8 } : {}
                }}
              >
                <Typography
                  color="textPrimary"
                  variant="h3"
                  sx={{ fontWeight: 800, fontSize: '1.75rem', letterSpacing: '-0.5px' }}
                >
                  {campaignValues.name}
                </Typography>
                {can('campaign.update', user.access_level === 0) && (
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                    Double-cliquez pour modifier le nom
                  </Typography>
                )}
              </Box>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2} justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
              <Grid item xs={12} sm={6} md="auto">
                <Box
                  onClick={() => {
                    if (can('campaign.update', user.access_level === 0) && !isEditing.start_date) {
                      handleToggle("start_date");
                    }
                  }}
                  sx={{
                    cursor: can('campaign.update', user.access_level === 0) && !isEditing.start_date ? 'pointer' : 'default',
                    p: 1.5,
                    borderRadius: '12px',
                    backgroundColor: theme.palette.mode === 'light' ? grey(0) : darkVeil(0.1),
                    border: '1px dashed',
                    borderColor: greyAlpha(200, 0.8)
                  }}
                >
                  {isEditing.start_date ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                      <DatePicker
                        label="Date de début"
                        format="DD/MM/YYYY"
                        open
                        onClose={() => stopEditing("start_date")}
                        onChange={(date) => {
                          if (!date || !dayjs(date).isValid()) {
                            return;
                          }
                          handleChangeDate(
                            "start_date",
                            dayjs(date).format("YYYY/MM/DD")
                          );
                        }}
                        slotProps={{ textField: { variant: "outlined", size: "small" } }}
                        value={dayjs(campaignValues.start_date)}
                      />
                    </LocalizationProvider>
                  ) : (
                    <Typography color="textPrimary" variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Début : <span style={{ color: getTone('blue').base }}>{dayjs(campaignValues.start_date).format("DD/MM/YYYY")}</span>
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md="auto">
                <Box
                  onClick={() => {
                    if (can('campaign.update', user.access_level === 0) && !isEditing.end_date) {
                      handleToggle("end_date");
                    }
                  }}
                  sx={{
                    cursor: can('campaign.update', user.access_level === 0) && !isEditing.end_date ? 'pointer' : 'default',
                    p: 1.5,
                    borderRadius: '12px',
                    backgroundColor: theme.palette.mode === 'light' ? grey(0) : darkVeil(0.1),
                    border: '1px dashed',
                    borderColor: greyAlpha(200, 0.8)
                  }}
                >
                  {isEditing.end_date ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                      <DatePicker
                        label="Date de fin"
                        format="DD/MM/YYYY"
                        open
                        onClose={() => stopEditing("end_date")}
                        onChange={(date) => {
                          if (!date || !dayjs(date).isValid()) {
                            return;
                          }
                          handleChangeDate(
                            "end_date",
                            dayjs(date).format("YYYY/MM/DD")
                          );
                        }}
                        slotProps={{ textField: { variant: "outlined", size: "small" } }}
                        value={dayjs(campaignValues.end_date)}
                      />
                    </LocalizationProvider>
                  ) : (
                    <Typography color="textPrimary" variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Fin : <span style={{ color: getTone('rose').base }}>{dayjs(campaignValues.end_date).format("DD/MM/YYYY")}</span>
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* Bouton "Commencer / Continuer la campagne" : permet de lancer la
          prospection en parcourant les fiches apprenants une à une.
          Le composant gère lui-même sa visibilité (type de campagne, état,
          commercial supprimé, etc.). */}
      <CampaignDetails />

      <Box sx={{ mb: 2 }}>
        <Tabs
          indicatorColor="primary"
          onChange={handleTabsChange}
          scrollButtons="auto"
          textColor="primary"
          value={currentTab}
          variant="scrollable"
          sx={{
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
              backgroundColor: 'primary.main'
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.95rem',
              minWidth: 120,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'primary.main',
              }
            }
          }}
        >
          {visibleTabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
      <Divider />
      {showTab("statistiques") && (
        <CampaignStatsTab
          setOpenReinjection={setOpenReinjection}
          setOpenRetrieve={setOpenRetrieve}
          setSelectedCommercialReinjection={setSelectedCommercialReinjection}
          setSelectedCommercialRetrieve={setSelectedCommercialRetrieve}
          idCampaign={idCampaign}
          donnees={donnees}
          progressionProspects={progressionProspects}
        />
      )}
      {showTab("Contacts") && (
        <>
          {can('campaign.contacts', user.access_level === 0 || user.id_service === 3) && (
            <Grid
              sx={{
                backgroundColor: "background.default",
                p: 1,
              }}
            >
              <CampaignLearner />
            </Grid>
          )}
        </>
      )}
      {showTab("logs") && (
        <>
          {can('campaign.tab.logs', user.access_level === 0) && (
            <Grid
              sx={{
                backgroundColor: "background.default",
                p: 1,
              }}
            >
              <CampaignLogs idCampaign={idCampaign} />
            </Grid>
          )}
        </>
      )}
      <Backdrop
        sx={{
          color: grey(0),
          zIndex: (themeLoader) => themeLoader.zIndex.drawer + 1,
        }}
        open={isLoadingPage}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default CampaignInfo;
